import $ from "jquery";
import jqueryBinary from "./jquery__binary.js";
import { auth } from "../utils/firebaseUtils";
//------------------------------------------------------------------------------
// Intenal dependencies
//------------------------------------------------------------------------------
import logger from "./LoggerFrontend";

//------------------------------------------------------------------------------
// config
//------------------------------------------------------------------------------
jqueryBinary($);

function buildURL(url) {
  return `${window.apiBaseURL || ""}${url}`;
}

//------------------------------------------------------------------------------
// Module dependencies
//------------------------------------------------------------------------------
class WebAPIUtils {
  getHistoricKeywordData(data) {
    return this.getEndpoint(`/api/v1/integrations/facebook/keywords/list/${data.externalId}`);
  }

  getAtsDataBackend(campaignId, utmSource, isDemo = false) {
    return this.getEndpointWithoutToken(
      `/api/v1/lead/${campaignId}?utm_source=${utmSource}?isDemo=${isDemo}`
    );
  }

  getAtsById(campaignId) {
    return this.getEndpoint(`/api/v2/ats/${campaignId}`);
  }

  copyCampaignOnChannel(channel, campaignId, tbCampaignId) {
    return this.postEndpoint(`/api/v1/integrations/${channel}/campaign/copy/${campaignId}`, {
      tbCampaignId
    });
  }

  changeFacebookCampaign(campaignId, params) {
    return this.postEndpoint(`/api/v1/integrations/facebook/campaign/change/${campaignId}`, params);
  }

  updateGoogleCampaignField(campaignId, params) {
    return this.postEndpoint(`/api/v1/integrations/google/change/${campaignId}`, params);
  }

  sendMessageToCampaignManager(orgaId, campaignId, params) {
    return this.postEndpoint(`/api/v1/campaign-management/message/${orgaId}/${campaignId}`, params);
  }

  changeFacebookAdset(campaignId, params) {
    return this.postEndpoint(`/api/v1/integrations/facebook/adset/change/${campaignId}`, params);
  }

  changeFacebookAdsetEndDate(campaignId, params) {
    return this.postEndpoint(
      `/api/v1/integrations/facebook/campaign/${campaignId}/adset/change`,
      params
    );
  }
  changeFacebookCampaignAdsetsAndAdsField(campaignId, params) {
    return this.postEndpoint(
      `/api/v1/integrations/facebook/campaign/${campaignId}/adsets/ads/change`,
      params
    );
  }
  updatePlatformCampaignsEndDates({ tbCampaignId, newEndDate }) {
    return this.postEndpoint(`/api/v1/platform-campaigns/${tbCampaignId}/update/endDate`, {
      newEndDate
    });
  }
  updateDestinationLink(tbCampaignId, tbAdsetId, updates) {
    logger.log("WebAPIUtils:Utils:updateDestinationLink", "called", {
      tbCampaignId,
      tbAdsetId,
      updates
    });

    return this.putEndpoint(
      `/api/v1/platform-campaigns/${tbCampaignId}/${tbAdsetId}/destinationLink`,
      {
        updates
      }
    );
  }
  getActivityStream() {
    return this.getEndpoint("/api/v1/integrations/facebook/activity-feed");
  }
  getFacebookPagesSpend(cache, matchTb) {
    logger.debug("WebAPIUtils:Utils:getFacebookPagesSpend", "called", cache, matchTb);
    return this.postEndpoint("/api/v1/integrations/facebook/pages-spend", { cache, matchTb });
  }
  getNewFacebookPages() {
    logger.debug("WebAPIUtils:Utils:getFacebookPagesSpend", "called");
    return this.getEndpoint("/api/v1/integrations/facebook/new-pages");
  }
  createQuote(data) {
    return this.postEndpoint(`/api/v1/invoicing/quotes`, data);
  }
  extractSentencesFromHTMl(data) {
    return this.postEndpoint("/api/v1/explorer/pipeline/html_extract", data);
  }
  getFacebookTargeting(campaignIdList) {
    return this.postEndpoint("/api/v1/integrations/facebook/targeting", { campaignIdList });
  }
  queryFacebookAudiences(query) {
    return this.getEndpoint(`/api/v1/integrations/facebook/audiences/search/${query}`);
  }
  queryFacebookAudiencesSuggestions(targeting) {
    return this.postEndpoint(`/api/v1/integrations/facebook/audiences/search/suggestions`, {
      targeting
    });
  }
  getHeadlineSuggestions(headline) {
    return this.getEndpoint(
      `/api/v1/integrations/google/headlines/suggestions?headline=${headline}`
    );
  }

  updateTargetingGoogleAds(orgaId, campaignId, params) {
    return this.postEndpoint(
      `/api/v1/googleAds/campaigns/targeting/${orgaId}/${campaignId}`,
      params
    );
  }
  /**
   *
   * @param {Object} params
   * @param {Object} params.adsetId - TalentBait Adset Id
   * @param {Object} params.newPageId - Facebook Page Id
   * @returns
   */
  changeFacebookPage({ adsetId, newPageId }) {
    return this.postEndpoint("/api/v1/campaigns/facebook/change-page", { adsetId, newPageId });
  }

  createTwitterCampaignWithPreviewData({ campaignId, adsetId, userProfile }) {
    return this.postEndpoint("/api/v1/twitter/campaign", { campaignId, adsetId, userProfile });
  }
  fetchCouponById(couponId) {
    return this.getEndpoint(`/api/v1/talentbait/coupons/${couponId}`);
  }
  getCampaignsWithCoupon(couponId) {
    return this.getEndpoint(`/api/v1/talentbait/campaign/coupons/${couponId}`);
  }
  validateCampaignCoupon(couponCode, campaignId, campaignData) {
    return this.postEndpoint(`/api/v1/talentbait/coupons/campaign/validate/`, {
      couponCode,
      campaignId,
      campaignData
    });
  }
  createCoupon({ code, description, discount, isEnabled, startDate, endDate, restrictions }) {
    return this.postEndpoint(`/api/v1/talentbait/coupons/`, {
      code,
      description,
      discount,
      isEnabled,
      startDate,
      endDate,
      restrictions
    });
  }
  updateCoupon({ id, code, description, discount, isEnabled, startDate, endDate, restrictions }) {
    return this.postEndpoint(`/api/v1/talentbait/coupons/${id}`, {
      code,
      description,
      discount,
      isEnabled,
      startDate,
      endDate,
      restrictions
    });
  }
  getPrepaidTransactions(organizationId) {
    return this.getEndpoint(`/api/v1/talentbait/${organizationId}/prepaid-transactions`);
  }
  getPrepaidBalance(organizationId) {
    return this.getEndpoint(`/api/v1/talentbait/${organizationId}/prepaid-accounts`);
  }
  getPrepaidPackages() {
    return this.getEndpoint(`/api/v1/talentbait/prepaid-accounts/packages`);
  }
  topUpPrepaidMoney({ organizationId, packageId, invoicing }) {
    return this.postEndpoint(`/api/v1/talentbait/${organizationId}/prepaid-accounts/top-up`, {
      packageId,
      invoicing
    });
  }
  setCampaignLive(
    campaignId,
    adsetId,
    channelGroupsToSetLive,
    meta,
    waitForChannels = false,
    shutterstockFlag
  ) {
    return this.postEndpointWithoutToken(
      `/api/v1/talentbait/campaign/${campaignId}/${adsetId}/live`,
      {
        channelGroupsToSetLive,
        meta,
        shutterstockFlag
      },
      { waitForChannels }
    );
  }
  createCampaignsOnChannels(
    campaignId,
    adsetId,
    groupsToCreate,
    orgaId,
    channels,
    userName,
    shutterstockFlag
  ) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/${campaignId}/${adsetId}/channels/live`, {
      groupsToCreate,
      orgaId,
      channels,
      userName,
      shutterstockFlag
    });
  }
  createTalentBaitCampaign(orgaId, campaignData, adPreviewData, adpreview) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/${orgaId}/`, {
      campaignData,
      adPreviewData,
      adpreview
    });
  }

  createTalentBaitCampaignWithId(orgaId, campaignData, adPreviewData, adpreview, campaignId) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/${orgaId}/with-id`, {
      campaignData,
      adPreviewData,
      adpreview,
      campaignId
    });
  }

  createInitialAdsetAndChannelCampaignsForCampaign(campaignId) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/${campaignId}/initial-adset`);
  }

  extendCampaign(campaignId, data) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/${campaignId}/adset`, data);
  }

  extendCampaignDate({ campaignId, daysToExtend }) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/${campaignId}/adset/end-date`, {
      daysToExtend
    });
  }

  updateTalentBaitCampaignStatus(campaignId, newStatus, userName, notify) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/status/${campaignId}/`, {
      newStatus,
      userName,
      notify
    });
  }

  triggerAutomaticCampaignReportTask(campaignId, time) {
    return this.postEndpoint(`/api/v1/talentbait/campaign/automaticReport/${campaignId}/`, {
      time
    });
  }

  toggleAdsetChannels(adsetId, channelsToToggle) {
    return this.postEndpoint(`/api/v1/talentbait/adset/channels/toggle`, {
      adsetId,
      channelsToToggle
    });
  }

  recalculateChannelCampaignsBudgets(adsetId) {
    return this.postEndpoint(
      `/api/v1/talentbait/adset/${adsetId}/recalculateChannelCampaignsBudgets`,
      {
        adsetId
      }
    );
  }

  createPlatformsChannelCampaignsOnAdset(adsetId, channels) {
    return this.postEndpoint(`/api/v1/talentbait/channelCampaigns/platforms`, {
      adsetId,
      channels
    });
  }

  deleteChannelCampaignById(channelCampaignId) {
    let uri = `/api/v1/talentbait/channelCampaigns/${channelCampaignId}`;

    return this.deleteEndpoint(uri);
  }

  loadCampaignDataPublic(tbCampaignId) {
    return this.getEndpointWithoutToken(`/api/v1/talentbait/campaign-public/${tbCampaignId}`);
  }

  loadAdsetDataPublic(adsetId) {
    return this.getEndpointWithoutToken(`/api/v1/talentbait/adset-public/${adsetId}`);
  }

  getAdsetsByCampaignIdPublic(campaignId) {
    return this.getEndpointWithoutToken(`/api/v1/talentbait/campaign-public/${campaignId}/adsets`);
  }
  loadCampaignWithV3Metrics(campaignId) {
    return this.getEndpoint(`/api/v1/campaigns/all?campaignId=${campaignId}`);
  }
  loadAllCampaignsAPI(filters) {
    const serializedFilters = filters
      ? `?` +
        Object.keys(filters)
          .map((key) => key + "=" + filters[key])
          .join("&")
      : "";

    return this.getEndpoint(`/api/v1/campaigns/all${serializedFilters}`);
  }

  loadFilteredCampaignsAPI({ organizationId, filters }) {
    const serializedFilters = filters
      ? `&` +
        Object.keys(filters)
          .map((key) => key + "=" + filters[key])
          .join("&")
      : "";

    return this.getEndpoint(
      `/api/v1/campaigns/filtered?organizationId=${organizationId}${serializedFilters}`
    );
  }

  loadSingleCampaignAPI(campaignId) {
    return this.getEndpoint(`/api/v1/campaigns/${campaignId}`);
  }

  // MEDIA ASSETS
  getMediaAssetById(mediaAssetId) {
    return this.getEndpoint(`/api/v2/media-assets/${mediaAssetId}`);
  }

  getMultipleMediaAssetByIds(mediaAssetIds) {
    return this.postEndpointWithoutToken(`/api/v2/media-assets/get-multiple`, mediaAssetIds);
  }

  deleteMultipleMediaAssets(mediaAssetIds) {
    return this.postEndpoint(`/api/v2/media-assets/delete`, mediaAssetIds);
  }

  createMultipleMediaAssets(mediaAssets) {
    return this.postEndpoint(`/api/v2/media-assets/`, mediaAssets);
  }

  duplicateMultipleMediaAssets(mediaAssetIds) {
    return this.postEndpoint(`/api/v2/media-assets/duplicate`, mediaAssetIds);
  }

  getAssetsByCampaignId(campaignId) {
    return this.getEndpoint(`/api/v2/campaign-assets/${campaignId}`);
  }
  //

  // CLOUDINARY
  getCloudinaryImages(campaignId) {
    return this.getEndpoint(`/api/v2/cloudinary/${campaignId}`);
  }

  getCloudinaryImagesByCompanyId(companyId) {
    return this.getEndpoint(`/api/v2/cloudinary/company/${companyId}`);
  }

  updateCloudinaryMetadataCampaignId({ campaignId, newCampaignId }) {
    const data = { campaignId, newCampaignId };
    return this.postEndpoint(`/api/v2/cloudinary/update`, data);
  }
  //

  getCampaignMembers(campaignId) {
    return this.getEndpoint(`/api/v2/campaigns/${campaignId}/members`);
  }

  updateCampaignMembers(campaignId, campaignMembers) {
    return this.postEndpoint(`/api/v2/campaigns/${campaignId}/members`, campaignMembers);
  }
  updateUser(userId, data) {
    return this.patchEndpoint(`/api/v2/users/${userId}`, data);
  }
  getAllCampaignManagers() {
    return this.getEndpointWithoutToken(`/api/v1/campaign-managers`);
  }

  getCampaignManagerById(id) {
    return this.getEndpointWithoutToken(`/api/v1/campaign-managers/${id}`);
  }

  updateCampaignManager(id, updates) {
    return this.postEndpointWithoutToken(`/api/v1/campaign-managers/${id}`, updates);
  }

  locationLookup(locations) {
    return this.postEndpoint("/api/v1/locations/map", locations);
  }

  searchStockImage(data) {
    return this.postEndpoint("/api/v1/images/stock", data);
  }

  searchShutterstockImagesAPI(data) {
    return this.getEndpoint("/api/v1/images/shutterstock", data);
  }

  searchShutterstockImagesAPIv2(data) {
    return this.getEndpoint("/api/v1/images/shutterstock/v2", data);
  }

  searchShutterstockAssets(data) {
    return this.getEndpoint(`/api/v1/images/shutterstock/assets?search=${data}`);
  }

  licenseShutterstockImageAPI(data) {
    return this.postEndpoint("/api/v1/images/shutterstock/license", data);
  }

  getUploadedImages(data) {
    return this.getEndpoint("/api/v1/images", data);
  }

  getUploadedLogos(data) {
    return this.getEndpoint("/api/v1/images/logos", data);
  }

  getImagesFromPath(data) {
    return this.getEndpoint("/api/v1/images-path", data);
  }

  getHistoricImages(data) {
    return this.getEndpoint("/api/v1/pictures", data);
  }

  archivePicture(data) {
    return this.postEndpoint("/api/v2/pictures/archive", data);
  }

  getImagesFromWebsite(data) {
    return this.postEndpoint("/api/v1/images/website", data);
  }

  getImagesFromWebsiteAndGenerateTemplates(data) {
    return this.postEndpoint("/api/v1/images/website-templates", data);
  }

  generateCampaignAdCreativesAssets(data) {
    return this.postEndpoint("/api/v1/images/generate-campaign-adcreatives-assets", data);
  }
  uploadMedia(data) {
    return this.postEndpointWithoutToken(`/api/v1/media`, data);
  }
  clearImageCache() {
    return this.postEndpoint("/api/v1/images/clear");
  }
  getTemplateImage(data) {
    return this.postEndpoint("/api/v1/images/template", data);
  }

  getSentences(data) {
    return this.postEndpoint("/api/v1/classification", data);
  }

  createNewFacebookPage(data) {
    logger.debug("WebAPIUtils:Utils:createNewFacebookPage", "called", data);
    return this.postEndpoint("/api/v1/classification/create-facebook-page", data);
  }

  getTeaserTextRecommendation(data) {
    return this.getEndpoint("/api/v1/teaser/", data);
  }

  createJobTitleKeywords(data) {
    return this.postEndpoint("/api/v1/keywords/jobtitle", data);
  }

  getKeywordsByJobTitle(search) {
    return this.getEndpoint(`/api/v1/keywords/search/${search}`);
  }

  getAllUserCampaignsById(userId) {
    return this.getEndpoint(`/api/v1/talentbait/campaign/user/${userId}`);
  }

  generateTextRecommendation(campaignId) {
    return this.postEndpoint(`/api/v1/text-summarization/${campaignId}`);
  }

  generateTextRecommendationStream({ body, onData }) {
    return new Promise((resolve, reject) =>
      this.postEndpoint(
        `/api/v1/text-summarization/stream`,
        undefined,
        undefined,
        async (url, idToken) => {
          const resp = await fetch(`${url}?idToken=${idToken}`, {
            method: "POST",
            headers: { Connection: "keep-alive" },
            body: JSON.stringify(body)
          });

          if (!resp.ok) {
            return reject();
          }

          const reader = resp.body.getReader();
          const decoder = new TextDecoder();

          // eslint-disable-next-line no-constant-condition
          while (true) {
            const { value, done } = await reader.read();

            if (done) {
              return resolve();
            }
            const decodedText = decoder.decode(value, { stream: true });

            if (decodedText.includes("event: error")) {
              return reject();
            }

            const formattedText = decodedText
              .split("data: ")
              .map((token) => token.slice(0, -2))
              .filter(Boolean)
              .join("");

            onData(formattedText);
          }
        }
      )
    );
  }

  saveClassification(data) {
    return this.postEndpoint("/api/v1/teaser", data);
  }

  saveJobCategoryLabel(data) {
    return this.postEndpoint("/api/v1/classification/job-category", data);
  }
  getJobCategory(data) {
    return this.postEndpoint("/api/v2/openAI/predictions/jobCategory", data);
  }

  generateThreadId(data) {
    return this.postEndpoint("/api/v2/openai/threads", data);
  }

  generateAssistantMessage(data) {
    return this.postEndpoint(`/api/v2/openai/campaign-assistant/chat-completion`, data);
  }

  getAssistantKeywordsByJobTitle(jobTitle) {
    return this.postEndpoint(`/api/v2/openai/predictions/keywords`, { jobTitle });
  }

  createLeadgenForm(data) {
    return this.postEndpoint("/api/v1/integrations/facebook/leadform", data);
  }
  fetchTikTokPreview(campaignId, tikTokCampaignId) {
    return this.getEndpoint(
      `/api/v1/integrations/tiktok/campaign/preview/${campaignId}/${tikTokCampaignId}`
    );
  }
  generateTikTokPreview(campaignId, data) {
    logger.log("WebAPIUtils:Utils:generateTikTokPreview", "called", data);
    return this.postEndpoint(`/api/v1/integrations/tiktok/campaign/${campaignId}`, data);
  }
  generateAudioClip(params) {
    return this.postEndpointWithoutTokenForm(
      `https://talentbait-ml-tts.herokuapp.com/voice`,
      params
    );
  }
  getAllJingles() {
    return this.getEndpoint("/api/v1/integrations/google/storage/jingles");
  }

  reassignCampaignManager(campaignId, params) {
    return this.postEndpoint("/api/v1/campaign-management/reassign/:campaignId", params);
  }
  getCampaignPerformanceScoring(params) {
    return this.postEndpoint("/api/v1/campaign-performance", params);
  }

  getGoogleAdText(data) {
    return this.postEndpoint("/api/v1/extract-google-preview-text/", data);
  }
  getIndeedAdText(data) {
    return this.postEndpoint("/api/v1/extract-indeed-preview-text/", data);
  }
  getLinkedinAdText(data) {
    return this.postEndpoint("/api/v1/extract-linkedin-preview-text/", data);
  }
  getAdPreviewData(data) {
    return this.postEndpoint("/api/v1/extract-adinformation", data);
  }
  generateJobPage(data) {
    return this.postEndpoint("/api/v1/job-page/", data);
  }

  getAdGeneratedPreviews(data) {
    return this.postEndpoint("/api/v1/adpreviews/generate", data);
  }
  getReachEstimate(data) {
    return this.postEndpoint("/api/v1/reach-estimate", data);
  }
  getPlacements(jobTitle, jobCategory) {
    return this.getEndpoint("/api/v1/placements", jobTitle, jobCategory);
  }
  getGooglePlacements(adwordsCampaignId) {
    return this.getEndpoint(`/api/v1/google-placements/fetch/${adwordsCampaignId}`);
  }
  removeGooglePlacements(placementId, data) {
    return this.postEndpoint(`/api/v1/google-placements/remove/${placementId}`, data);
  }
  //
  // Returns keywords extracted by the "keywords recognition engine" given a job posts link
  getKeywordsJobDescription(data) {
    return this.postEndpoint("/api/v1/get-keywords", data);
  }

  // Creates google campaings
  createGoogleCampaign(data) {
    return this.postEndpoint("/api/v1/google/campaigns", data);
  }
  // Creates google search campaing with Google Ads
  createGoogleSearchCampaignV2(data) {
    return this.postEndpoint("/api/v1/google-search/campaigns", data);
  }
  createSnapchatCampaign({ campaignId, orgaId }) {
    return this.postEndpoint("/api/v1/campaigns/channels", {
      campaignId,
      channels: ["snapchat"]
    });
  }
  // Creates Campaigns on channels
  createChannelCampaigns({ campaignId, channels, user, adsetId, orgaId }) {
    return this.postEndpoint("/api/v1/campaigns/channels", {
      campaignId,
      user,
      channels,
      adsetId,
      orgaId
    });
  }
  loadInvoices(orgaId) {
    return this.getEndpoint(`/api/v1/invoicing/organizations/${orgaId}/invoices`);
  }
  archiveInvoicingOrganization({ invoicingOrganizationId, organizationId }) {
    return this.postEndpoint(`/api/v1/invoicing/organizations/${invoicingOrganizationId}/archive`, {
      organizationId
    });
  }
  createDebitoorCompany(data) {
    return this.postEndpoint("/api/v1/invoicing/organizations", data);
  }

  sendExternalCampaignStatus(campaignId, newStatus) {
    // Send a status update to external source (onlyfy)
    return this.postEndpoint(`/api/v1/integrations/external/campaigns/${campaignId}/status`, {
      newStatus
    });
  }
  getCustomerAddress(customerId) {
    return this.getEndpoint(`/api/v1/invoicing/organizations/${customerId}`);
  }
  createInvoice(organizationId, campaignId) {
    return this.postEndpoint(`/api/v1/invoicing/invoices`, {
      organizationId,
      campaignId
    });
  }
  sendInvoice(invoiceId, { organizationId, campaignId, adsetId }) {
    return this.postEndpoint(`/api/v1/invoicing/invoices/send/${invoiceId}`, {
      organizationId,
      campaignId,
      adsetId
    });
  }
  updateCampaignInvoicePosition(campaignId, data) {
    return this.postEndpoint(`/api/v1/invoicing/invoices/update/${campaignId}`, data);
  }
  notifiy(orgaId, campaignId, data) {
    // Sends a slack notification to our dedicated channel for it.
    return this.postEndpoint(`/api/v1/notify/${orgaId}/${campaignId}`, data);
  }
  sendSlack(data) {
    // Sends a slack notification to the channel selected
    return this.postEndpoint(`/api/v1/slack`, data);
  }
  // Returns the clicks and impressions of a given campaign broken downn by day.
  metricsByDay(orgaId, campaignId, datePreset) {
    return this.getEndpointWithoutToken(
      `/api/v1/integrations/facebook/metrics-per-day/${orgaId}/${campaignId}/${datePreset}`
    );
  }

  createReport(campaignId, campaignData) {
    return this.postEndpoint(`/api/v1/report/${campaignId}`, campaignData);
  }

  async generateReport(campaignId, orgaId, campaignGoal, publicPDFUrl, showCreativeTable) {
    logger.log("WebAPIUtils:Utils:generateReport", "called... data", {
      campaignId,
      orgaId,
      campaignGoal,
      publicPDFUrl,
      showCreativeTable
    });
    if (showCreativeTable || campaignGoal === "applicants") {
      window.open(publicPDFUrl, "_blank");
    } else {
      // For Agencies we use our old pdf
      logger.log("WebAPIUtils:Utils:downloadPdf", "calling downloading pdf with old way", {
        campaignId
      });

      return new Promise(function (fulfill, reject) {
        if (window.emulatorConfig && window.emulatorConfig.auth) {
          auth.useEmulator(window.emulatorConfig.auth);
        }

        auth.currentUser
          .getIdToken(true)
          .then(function (idToken) {
            $.ajax({
              url: `/api/v1/documents/export/pdf/${campaignId}?idToken=${idToken}`,
              type: "GET",
              dataType: "binary",
              responseType: "arraybuffer",
              processData: false,
              success: function (data) {
                // Pass extra parameters to fulfill
                fulfill({ pdf: data, showCreativeTable });
              },
              error: reject
            });
          })
          .catch((err) => {
            logger.log("error:WebAPIUtils:Utils:getEndpoint", "called", { err, campaignId });
            reject("No Token Send downloadPdf");
          });
      });
    }
  }

  enqueueSingleReport(campaignId) {
    logger.log("WebAPIUtils:Utils:enqueueSingleReport", "enqueueSingleReport called", campaignId);
    return this.postEndpoint(`/api/v1/pdf/enqueue-report`, campaignId);
  }

  getCampaignCandidateMetrics(campaignId) {
    logger.log("WebAPIUtils:Utils:getCampaignCandidateMetrics", "called", campaignId);

    return this.getEndpoint(`/api/v1/campaigns/${campaignId}/candidate-metrics`, {});
  }

  getDailyCandidateMetrics(campaignId) {
    logger.log("WebAPIUtils:Utils:getDailyCandidateMetrics", "called", campaignId);

    return this.getEndpoint(`/api/v1/campaigns/${campaignId}/candidate-metrics/daily`, {});
  }

  updateCandidatesByCampaignId(data) {
    logger.log("WebAPIUtils:Utils:updateCandidatesByCampaignId", "called", data);

    return this.patchEndpoint(`/api/v2/candidates`, data);
  }

  getEmployerBrandingMetrics(campaignId, adsetId) {
    logger.log("WebAPIUtils:Utils:getEmployerBrandingMetrics", "called", { campaignId, adsetId });

    const queryParams = new URLSearchParams();
    if (adsetId) {
      queryParams.append("adsetId", adsetId);
    }

    return this.getEndpoint(`/api/v2/metrics/${campaignId}/aggregate?${queryParams.toString()}`);
  }

  getPerformanceMetrics(campaignId) {
    logger.log("WebAPIUtils:Utils:getPerformanceMetrics", "called", { campaignId });

    return this.getEndpoint(`/api/v2/metrics/${campaignId}/performance`);
  }

  downloadPdf(campaignId) {
    logger.log("WebAPIUtils:Utils:downloadPdf", "called", campaignId);
    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      auth.currentUser
        .getIdToken(true)
        .then(function (idToken) {
          $.ajax({
            url: `/api/v1/documents/export/pdf/${campaignId}?idToken=${idToken}`,
            type: "GET",
            dataType: "binary",
            responseType: "arraybuffer",
            processData: false,
            success: fulfill,
            error: reject
          });
        })
        .catch((err) => {
          logger.log("error:WebAPIUtils:Utils:getEndpoint", "called", err);
          reject("No Token Send downloadPdf");
        });
    });
  }
  sendLiveLink(orgaId, campaignId, data) {
    return this.postEndpoint(`/api/v1/integrations/gohiring/live/${orgaId}/${campaignId}`, data);
  }

  getPersonioJobs(data) {
    return this.getEndpoint(`/api/v1/integrations/personio/jobs`, data);
  }

  getRecruiteeJobs(data) {
    return this.getEndpoint(`/api/v1/integrations/recruitee/jobs`, data);
  }

  getRecruiteeJobById(jobId, orgaId) {
    return this.getEndpoint(`/api/v1/integrations/recruitee/jobs/${jobId}/${orgaId}`);
  }

  getCampaignManager() {
    return this.getEndpoint("/api/v1/campaign-management/campaign-managers");
  }
  message(data) {
    return this.postEndpoint("/api/v1/message", data);
  }
  newSession(data) {
    return this.postEndpoint("/api/v1/session", data);
  }
  newComment(orgaId, campaignId, data) {
    return this.postEndpoint(`/api/v1/email/comment/${orgaId}/${campaignId}`, data);
  }
  getScore(jobPostingUrl) {
    return this.postEndpoint("/api/v1/health/score", {
      jobPostingUrl: jobPostingUrl
    });
  }
  getAssets(assetIds) {
    return this.getEndpoint(`/api/v2/assets?ids=${assetIds.toString()}`);
  }
  saveAssets(orgaId, companyId, assets) {
    return this.postEndpoint(`/api/v2/assets/${orgaId}/${companyId}`, { assets });
  }
  deleteCreativeAsset(adCreativeId, data) {
    return this.deleteEndpoint(`/api/v2/assets/${adCreativeId}`, data);
  }
  getAdCreativesByCampaignId(campaignId) {
    return this.getEndpoint(`/api/v2/creatives?campaignId=${campaignId}`);
  }
  updateAdCreative(adCreativeId, data) {
    return this.postEndpoint(`/api/v2/creatives/${adCreativeId}`, data);
  }
  deleteAdCreativesByCampaignId(campaignId) {
    return this.deleteEndpoint(`/api/v2/creatives/?campaignId=${campaignId}`);
  }
  createAdCreative(data) {
    return this.postEndpoint("/api/v2/creatives", data);
  }
  //Explorer endpoints
  getKeywords(data) {
    return this.postEndpoint("/api/v1/explorer/keywords", data);
  }
  // Applicant enpoints
  sendApplicantMessage(data) {
    return this.postEndpoint("/api/v1/applicant/conversations", data);
  }
  sendApplicantEmail(data) {
    return this.postEndpoint("/api/v1/applicant/conversations/email", data);
  }
  getConversations(data) {
    return this.postEndpoint("/api/v1/applicant/conversations/subscribe", data);
  }
  pingCSMNewCampaign(orgaId, campaignId, params) {
    return this.postEndpoint(
      `/api/v1/campaign-management/new-campaign/${orgaId}/${campaignId}`,
      params
    );
  }

  postEndpointWithoutTokenForm(endpoint, data) {
    const url = buildURL(endpoint);
    logger.log("WebAPIUtils:Utils:postEndpointWithoutToken", "called", {
      url,
      ...data
    });

    return new Promise(function (fulfill) {
      var settings = {
        url: "https://talentbait-ml-tts.herokuapp.com/voice",
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: data
      };

      $.ajax(settings).done(function (response) {
        fulfill(response);
      });
    });
  }

  postEndpointWithoutToken(endpoint, data) {
    const url = buildURL(endpoint);
    logger.log("WebAPIUtils:Utils:postEndpointWithoutToken", "called", { url, ...data });

    return new Promise(function (fulfill, reject) {
      const settings = {
        url,
        data,
        method: "POST",
        success: fulfill,
        error: reject
      };

      return $.ajax(settings).catch((err) => {
        logger.log("error:WebAPIUtils:Utils:postEndpointWithoutToken", "failed", { url, err });
      });
    });
  }

  async putEndpoint(endpoint, data, queryParams = {}) {
    const url = buildURL(endpoint);

    logger.debug("WebAPIUtils:Utils:putEndpoint", "called", {
      url,
      ...data,
      queryParams
    });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      const successFulHandler = function (idToken) {
        const settings = {
          async: true,
          crossDomain: true,
          url: url + "?" + $.param({ ...queryParams, idToken: idToken }),
          data,
          method: "PUT",
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
          },
          success: fulfill,
          error: reject
        };

        return $.ajax(settings);
      };

      auth.currentUser
        .getIdToken(true)
        .then(successFulHandler)
        .catch((err) => {
          logger.log("error:WebAPIUtils:Utils:putEndpoint", "called", {
            err,
            url,
            ...data
          });
          // This is a workaround for the fact that Facebook pages as a instagram account sometimes fail to get the token,
          // and we need to try again
          auth.currentUser
            .getIdToken(true)
            .then(successFulHandler)
            .catch((err) => {
              logger.log("error:WebAPIUtils:Utils:putEndpoint", "trying again", {
                err,
                url,
                ...data
              });
              reject("No Token Send");
            });
        });
    });
  }

  async putEndpointWithJSON(endpoint, data, queryParams = {}) {
    const url = buildURL(endpoint);

    logger.debug("WebAPIUtils:Utils:putEndpoint", "called", {
      url,
      ...data,
      queryParams
    });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      const successFulHandler = function (idToken) {
        const settings = {
          async: true,
          crossDomain: true,
          url: url + "?" + $.param({ ...queryParams, idToken: idToken }),
          data: JSON.stringify(data),
          processData: false,
          method: "PUT",
          headers: {
            "content-type": "application/json",
            "cache-control": "no-cache"
          },
          success: fulfill,
          error: reject
        };

        return $.ajax(settings);
      };

      auth.currentUser
        .getIdToken(true)
        .then(successFulHandler)
        .catch((err) => {
          logger.log("error:WebAPIUtils:Utils:putEndpoint", "called", {
            err,
            url,
            ...data
          });
          // This is a workaround for the fact that Facebook pages as a instagram account sometimes fail to get the token,
          // and we need to try again
          auth.currentUser
            .getIdToken(true)
            .then(successFulHandler)
            .catch((err) => {
              logger.log("error:WebAPIUtils:Utils:putEndpoint", "trying again", {
                err,
                url,
                ...data
              });
              reject("No Token Send");
            });
        });
    });
  }

  postEndpoint(endpoint, data, queryParams = {}, handler) {
    const url = buildURL(endpoint);

    logger.log("WebAPIUtils:Utils:postEndpoint", "post endpoint was called", {
      url,
      ...data,
      queryParams
    });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      const defaultHandler = function (idToken) {
        const settings = {
          async: true,
          crossDomain: true,
          url: url + "?" + $.param({ ...queryParams, idToken: idToken }),
          data,
          method: "POST",
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
          },
          success: fulfill,
          error: reject
        };

        return $.ajax(settings);
      };

      const successFulHandler = handler
        ? (idToken) => handler(url, idToken).then(fulfill, reject)
        : defaultHandler;

      auth.currentUser.getIdToken(true).then(successFulHandler, (error) => {
        logger.log("error:WebAPIUtils:Utils:postEndpoint", "Error executing post endpoint", {
          error,
          url,
          ...data
        });

        reject(error);
      });
    });
  }

  postEndpointJSON(endpoint, data, queryParams = {}, handler) {
    const url = buildURL(endpoint);

    logger.log("WebAPIUtils:Utils:postEndpoint", "post endpoint was called", {
      url,
      ...data,
      queryParams
    });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      const defaultHandler = function (idToken) {
        const settings = {
          async: true,
          crossDomain: true,
          url: url + "?" + $.param({ ...queryParams, idToken: idToken }),
          data: JSON.stringify(data),
          processData: false,
          method: "POST",
          headers: {
            "content-type": "application/json",
            "cache-control": "no-cache"
          },
          success: fulfill,
          error: reject
        };

        return $.ajax(settings);
      };

      const successFulHandler = handler
        ? (idToken) => handler(url, idToken).then(fulfill, reject)
        : defaultHandler;

      auth.currentUser.getIdToken(true).then(successFulHandler, (error) => {
        logger.log("error:WebAPIUtils:Utils:postEndpoint", "Error executing post endpoint", {
          error,
          url,
          ...data
        });

        reject(error);
      });
    });
  }

  /**
  @todo Refactor endpoint methods
  */
  patchEndpoint(endpoint, data, queryParams = {}, handler) {
    const url = buildURL(endpoint);

    logger.log("WebAPIUtils:Utils:patchEndpoint", "patch endpoint was called", {
      url,
      ...data,
      queryParams
    });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      const defaultHandler = function (idToken) {
        const settings = {
          async: true,
          crossDomain: true,
          url: url + "?" + $.param({ ...queryParams, idToken: idToken }),
          data: JSON.stringify({ ...data }),
          method: "PATCH",
          headers: {
            "content-type": "application/json",
            "cache-control": "no-cache"
          },
          success: fulfill,
          error: reject
        };

        return $.ajax(settings);
      };

      const successFulHandler = handler
        ? (idToken) => handler(url, idToken).then(fulfill, reject)
        : defaultHandler;

      auth.currentUser.getIdToken(true).then(successFulHandler, (error) => {
        logger.log("error:WebAPIUtils:Utils:patchEndpoint", "Error executing patch endpoint", {
          error,
          url,
          ...data
        });

        reject(error);
      });
    });
  }

  getEndpointWithoutToken(endpoint, data = {}) {
    const url = buildURL(endpoint);
    logger.debug("WebAPIUtils:Utils:getEndpointWithoutToken", "called", { url, endpoint, ...data });

    return new Promise(function (fulfill, reject) {
      const settings = {
        async: true,
        crossDomain: true,
        url,
        data,
        method: "GET",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        success: fulfill,
        error: reject
      };

      return $.ajax(settings);
    });
  }

  getEndpoint(endpoint, data = {}) {
    const url = buildURL(endpoint);
    logger.debug("WebAPIUtils:Utils:getEndpoint", "called", { url, endpoint, ...data });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      auth.currentUser
        .getIdToken(true)
        .then(function (idToken) {
          const settings = {
            async: true,
            crossDomain: true,
            url,
            data: {
              ...data,
              // Make sure the ID token is always set after the passed in data
              // not to overwrite the authentication token
              idToken: idToken
            },
            method: "GET",
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
            },
            success: fulfill,
            error: reject
          };

          return $.ajax(settings);
        })
        .catch((err) => {
          logger.log("error:WebAPIUtils:Utils:getEndpoint", "called", {
            err,
            url,
            ...data
          });
          reject("No Token Send");
        });
    });
  }

  deleteEndpoint(endpoint, data = {}) {
    const url = buildURL(endpoint);
    logger.debug("WebAPIUtils:Utils:deleteEndpoint", "called", { url, endpoint, ...data });

    return new Promise(function (fulfill, reject) {
      if (window.emulatorConfig && window.emulatorConfig.auth) {
        auth.useEmulator(window.emulatorConfig.auth);
      }

      auth.currentUser
        .getIdToken(true)
        .then(function (idToken) {
          const settings = {
            async: true,
            crossDomain: true,
            url:
              url +
              "?" +
              $.param({
                ...data,
                // Make sure the ID token is always set after the passed in data
                // not to overwrite the authentication token

                idToken
              }),
            method: "DELETE",
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
            },
            success: fulfill,
            error: reject
          };

          return $.ajax(settings);
        })
        .catch((err) => {
          logger.log("error:WebAPIUtils:Utils:deleteEndpoint", "called", {
            err,
            url,
            ...data
          });
          reject("No Token Sent");
        });
    });
  }

  createUserLogsFlat(data) {
    return this.postEndpoint(`/api/v2/users-logs-flat/`, data);
  }

  loadOrganization(orgaId) {
    return this.getEndpoint(`/api/v2/organizations/${orgaId}`);
  }

  trackSegmentEvent(data) {
    return this.postEndpoint(`/api/v2/segment/track`, data);
  }

  identifySegmentEvent(data) {
    return this.postEndpoint(`/api/v2/segment/identify`, data);
  }

  groupSegmentEvent(data) {
    return this.postEndpoint(`/api/v2/segment/group`, data);
  }

  pageSegmentEvent(data) {
    return this.postEndpoint(`/api/v2/segment/page`, data);
  }

  getAggregatedCreativeMetricsByHash(data) {
    return this.postEndpoint(`/api/v2/metrics/aggregateCreativeMetricsByHash`, {
      creativeMetrics: data
    });
  }

  updateCampaignEndDate(campaignId, data) {
    return this.patchEndpoint(`/api/v2/campaigns/${campaignId}/end-date`, data);
  }

  saveQuestionsMapping(campaignId, data) {
    return this.patchEndpoint(`/api/v1/campaigns/${campaignId}/question-mapping`, data);
  }

  generateShareLinkForCampaign(campaignId) {
    logger.log("WebAPIUtils:Utils:generateShareLinkForCampaign", "called", { campaignId });
    return this.postEndpoint(`/api/v2/public-creatives/${campaignId}/share`);
  }

  loadSharedCampaignData(campaignId, token) {
    logger.log("WebAPIUtils:Utils:loadSharedCampaignData", "called", { campaignId, token });
    return this.getEndpointWithoutToken(
      `/api/v2/public-creatives/${campaignId}/shared?token=${token}`
    );
  }

  // Assistant endpoints
  setAdAssistantCampaignLive(campaignId) {
    return this.postEndpoint(`/api/v3/campaigns/${campaignId}/live`);
  }

  createAssistantCampaign(data) {
    return this.postEndpointJSON(`/api/v3/campaigns`, data);
  }

  updateAssistantCampaign(data, campaignId) {
    return this.patchEndpoint(`/api/v3/campaigns/${campaignId}`, data);
  }

  getAssistantCampaign(campaignId) {
    return this.getEndpoint(`/api/v3/campaigns/${campaignId}`);
  }

  getAdCombinations(campaignId) {
    const queryParams = new URLSearchParams();
    if (campaignId) {
      queryParams.append("campaignId", campaignId);
    }

    return this.getEndpoint(`/api/v2/ads/combinations?${queryParams.toString()}`);
  }

  createAd(data) {
    return this.postEndpointJSON(`/api/v2/ads`, data);
  }

  updateAd(data, adId) {
    return this.putEndpointWithJSON(`/api/v2/ads/${adId}`, data);
  }

  getAdVersions(adId, { offset, limit } = {}) {
    const queryParams = new URLSearchParams();
    if (offset) {
      queryParams.append("offset", offset);
    }
    if (limit) {
      queryParams.append("limit", limit);
    }

    return this.getEndpoint(`/api/v2/ads/${adId}/versions?${queryParams.toString()}`);
  }

  setActiveAdVersion(adId, versionId) {
    return this.putEndpoint(`/api/v2/ads/${adId}/versions/active/${versionId}`);
  }

  getOrCreateCompany(data) {
    return this.postEndpoint(`/api/v2/companies`, data);
  }

  getAllCompanies(organizationId) {
    return this.getEndpoint(`/api/v2/companies?organizationId=${organizationId}`);
  }

  // Jobs endpoints
  getJobs(orgaId) {
    return this.getEndpoint(`/api/v2/jobs?orgaId=${orgaId}`);
  }

  fetchAndSaveJobs(orgaId) {
    return this.postEndpoint(`/api/v1/integrations/onlyfy/jobs`, { orgaId });
  }

  createCampaignBasedOnJob(jobId) {
    return this.postEndpoint(`/api/v2/jobs/${jobId}/campaign`);
  }

  getProfile(profileId) {
    return this.getEndpoint(`/api/v2/profiles/${profileId}`);
  }

  patchProfile(profileId, data) {
    return this.patchEndpoint(`/api/v2/profiles/${profileId}`, data);
  }

  createProfile(data) {
    return this.postEndpoint(`/api/v2/profiles`, data);
  }

  deleteProfile(profileId) {
    return this.deleteEndpoint(`/api/v2/profiles/${profileId}`);
  }

  getProfileByOrganizationId(profileId, organizationId) {
    return this.getEndpoint(`/api/v2/profiles/${profileId}/?organizationId=${organizationId}`);
  }

  getProfilesByOrganizationId(organizationId) {
    return this.getEndpoint(`/api/v2/profiles?organizationId=${organizationId}`);
  }

  getDomainSkillsByJobCategoryId(jobCategoryId) {
    return this.getEndpoint(`/api/v2/domain-skills?jobCategoryId=${jobCategoryId}`);
  }

  getCategoriesByJobCategoryId(jobCategoryId) {
    return this.getEndpoint(`/api/v2/categories?jobCategoryId=${jobCategoryId}`);
  }

  generateWhatsappForm(profileId) {
    return this.postEndpoint(`/api/v2/profiles/${profileId}/whatsapp-form`);
  }

  createDomainSkill(data) {
    return this.postEndpointJSON(`/api/v2/domain-skills`, data);
  }

  getActiveCampaignCount(organizationId) {
    return this.getEndpoint(`/api/v3/campaigns/count?organizationId=${organizationId}`);
  }

  getActiveApplicantsCount(organizationId) {
    return this.getEndpoint(`/api/v2/candidates/count?organizationId=${organizationId}`);
  }

  getHelloMessage(language) {
    return this.getEndpoint(`/api/v2/daily-facts?language=${language}`);
  }

  likeCloudinaryAsset({ assetPublicId, type, isLiked }) {
    return this.patchEndpoint("/api/v2/cloudinary/assets/like", {
      assetPublicId,
      type,
      isLiked
    });
  }
}

const instance = new WebAPIUtils();
export default instance;
